import React, { createContext, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from './useLocalStorage.hook';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage('user', null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data) => {
    setUser(data);

    navigate('/student');
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
  };

  const getToken = () => {
    const value = window.localStorage.getItem('user');
    return JSON.parse(value);
  }

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      getToken
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
